import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3a3780d0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "not-found"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下载中心", -1));

import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
export default {
  __name: 'detail-404',

  setup(__props) {
    const router = useRouter();

    const handleTo = path => {
      router.push(path);
    };

    document.title = '找不到该文件｜深圳市共熵产业与标准创新服务中心';
    return (_ctx, _cache) => {
      const _component_el_empty = _resolveComponent("el-empty");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_empty, {
        description: "找不到该文件。"
      }), _createElementVNode("div", {
        class: "hint",
        onClick: _cache[0] || (_cache[0] = $event => handleTo('/item-list'))
      }, [_createTextVNode(" 前往"), _hoisted_2])]);
    };
  }

};